import PropTypes from 'prop-types'

import portCallReport from './portCallReport'
import terminalPerformanceReport from './terminalPerformanceReport'

export default PropTypes.shape({
  portCallReport,
  terminalPerformanceReport,
})
